module.exports = "<stats-page></stats-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appStats.html
// module id = 1635
// module chunks = 0